import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"
import { SelectCustom } from "../../../ui/molecules/select"
import { ConformityOptions, M024Type } from "../../../utils"
import { Calendar } from "../../../ui/molecules/calendar"
import { SingleCheckbox } from "../../../ui/molecules/SingleCheckbox"
import { useState } from "react"
import TextArea from "../../../ui/molecules/textArea"
import { ProtocolSelectByObject } from "../../../ui/molecules/ProtocolSelectByObj"
import { Select } from "@mui/material"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import { setM024UpdateadmConformity, setM024UpdateAdmRegularityProtocol, setM024UpdateCertificationDocumentM014, setM024UpdateCertificationDocumentM020, setM024UpdateCertificationDocumentM021, setM024UpdateCertificationDocumentM023, setM024UpdateCertificationDocumentM029, setM024UpdateCertificationDocumentNaqs, setM024UpdateCertificationDocumentNop, setM024UpdateIssueDate, setM024UpdateNopDetails, setM024UpdateOtherReason, setM024UpdateReasonsEmissionM029Request, setM024UpdateReasonsEmissionM029Rev, setM024UpdateReasonsEmissionNot, setM024UpdateReasonsEmissionPsr, setM024UpdateRequestCertProtocol } from "./slice"

interface Props {
    documentType?: 'VALUTAZIONE' | 'RIESAME' | 'DECISIONE'
}

export function M024OptionsForm(props: Props) {
    const {documentType} = props
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [m029fFlag, setM029fFlag] = useState<boolean>(false)
    const [m014fFlag, setM014fFlag] = useState<boolean>(false)
    const [m020fFlag, setM020fFlag] = useState<boolean>(false)
    const [m021fFlag, setM021fFlag] = useState<boolean>(false)
    const [nopfFlag, setNopfFlag] = useState<boolean>(false)
    const [m023fFlag, setM023fFlag] = useState<boolean>(false)
    const [naqsfFlag, setNaqsfFlag] = useState<boolean>(false)
    const [m029RevFlag, setM029RevFlag] = useState<boolean>(false)
    const [notificaFlag, setNotificaFlag] = useState<boolean>(false)
    const [psrFlag, setPsrFlag] = useState<boolean>(false)
    const [m029RequestFlag, setM029RequestFlag] = useState<boolean>(false)

    return (
        <div style={{ padding: '0px 24px' }}>
            <div style={{ padding: '24px 0px' }}>
                <div className="w-[20%]">
                    <Calendar
                        label="Data Emissione"
                        onChange={(date) => dispatch(setM024UpdateIssueDate(date))}
                    />
                </div>
            </div>
            <div className="ml-1 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div className='text-left assignment-text-content'>
                    Documento di certificazione
                </div>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>

                    <SingleCheckbox
                        label='M029'
                        checked={m029fFlag}
                        setChecked={(value) => {
                            setM029fFlag(value)
                            dispatch(setM024UpdateCertificationDocumentM029(value))
                        }}
                    />
                    <SingleCheckbox
                        label='M014'
                        checked={m014fFlag}
                        setChecked={(value) => {
                            setM014fFlag(value)
                            dispatch(setM024UpdateCertificationDocumentM014(value))
                        }}
                    />
                    <SingleCheckbox
                        label='M020'
                        checked={m020fFlag}
                        setChecked={(value) => {
                            setM020fFlag(value)
                            dispatch(setM024UpdateCertificationDocumentM020(value))
                        }}
                    />
                    <SingleCheckbox
                        label='M021'
                        checked={m021fFlag}
                        setChecked={(value) => {
                            setM021fFlag(value)
                            dispatch(setM024UpdateCertificationDocumentM021(value))
                        }}
                    />
                    <SingleCheckbox
                        label='NOP'
                        checked={nopfFlag}
                        setChecked={(value) => {
                            setNopfFlag(value)
                            dispatch(setM024UpdateCertificationDocumentNop(value))
                        }}
                    />
                    <SingleCheckbox
                        label='M023'
                        checked={m023fFlag}
                        setChecked={(value) => {
                            setM023fFlag(value)
                            dispatch(setM024UpdateCertificationDocumentM023(value))
                        }}
                    />
                    <SingleCheckbox
                        label='NAQS'
                        checked={naqsfFlag}
                        setChecked={(value) => {
                            setNaqsfFlag(value)
                            dispatch(setM024UpdateCertificationDocumentNaqs(value))
                        }}
                    />
                </div>
            </div>
            <div className="w-[30%] mt-4">
                <TextArea
                    label="Certificati NOP"
                    onChangeText={(text) => dispatch(setM024UpdateNopDetails(text))}
                />
            </div>
            <div className="text-left mt-4">
                <span style={{ fontSize: '18px' }}>Cause Emissione M024</span>
            </div>
            <div className="mt-4" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                <SingleCheckbox
                    label='Revisione M029 - da Revisionare'
                    checked={m029RevFlag}
                    setChecked={(value) => {
                        setM029RevFlag(value)
                        dispatch(setM024UpdateReasonsEmissionM029Rev(value))
                    }}
                />
                <SingleCheckbox
                    label="Notifica (Prima notifica e/o notifica di variazione)"
                    checked={notificaFlag}
                    setChecked={(value) => {
                        setNotificaFlag(value)
                        dispatch(setM024UpdateReasonsEmissionNot(value))
                    }}
                />
                <SingleCheckbox
                    label="Richiesta a seguito di PSR"
                    checked={psrFlag}
                    setChecked={(value) => {
                        setPsrFlag(value)
                        dispatch(setM024UpdateReasonsEmissionPsr(value))
                    }}
                />
                <SingleCheckbox
                    label="Richiesta dell'operatore per M029"
                    checked={m029RequestFlag}
                    setChecked={(value) => {
                        setM029RequestFlag(value)
                        dispatch(setM024UpdateReasonsEmissionM029Request(value))
                    }}
                />
                <ProtocolSelectByObject
                    placeholder="Ricerca Protocollo Richiesta M029"
                    type={'entry'}
                    objectId="1"
                    onChange={(value) => dispatch(setM024UpdateRequestCertProtocol(value))}
                />
            </div>

            <div className="w-[30%] mt-4">
                <TextArea
                    label="Altro"
                    placeholder="Indicare altro"
                    onChangeText={(text) => dispatch(setM024UpdateOtherReason(text))}
                />
            </div>
            <div className="mt-4 text-left pb-4">
                <span style={{ fontSize: '18px' }}>
                    Regolarità amministrative (Quota di controllo e certificazione)
                </span>

                <div className="flex gap-4 mt-2">
                    <div className="w-[30%]">
                        <SelectCustom
                            placeholder="Conformità"
                            label="Conformità"
                            options={ConformityOptions}
                            onChange={(value) => dispatch(setM024UpdateadmConformity(value))}
                        />
                    </div>
                    <div className="w-[70%]">
                        <ProtocolSearch
                            label="Protocollo Regolarità amministrativa"
                            type="entry"
                            onSelect={(value) => dispatch(setM024UpdateAdmRegularityProtocol(value))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )


}